import { render, staticRenderFns } from "./vue-tags-input.vue?vue&type=template&id=6f557294&"
import script from "./vue-tags-input.js?vue&type=script&lang=js&"
export * from "./vue-tags-input.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vue-tags-input.vue"
export default component.exports